"use client"

import { useGlobalActions } from "@/hooks/use-global-actions"
import { useKeyboardShortcut } from "@/hooks/use-keyboard-shortcut"

export function GlobalHotkeys() {
  const globalActions = useGlobalActions()

  useKeyboardShortcut("mod+k", globalActions["open-command-palette"], {
    description: "Open command palette",
    category: "Global",
    enableOnFormTags: true,
  })

  useKeyboardShortcut("?", globalActions["show-help-chat"], {
    description: "Show help chat",
    category: "Global",
    useKey: true,
  })

  useKeyboardShortcut("c>t", globalActions["create-task"], {
    description: "Create new task",
    category: "Actions",
  })
  useKeyboardShortcut("c>n", globalActions["create-note"], {
    description: "Create new note",
    category: "Actions",
  })
  useKeyboardShortcut("c>c", globalActions["create-client"], {
    description: "Create new client",
    category: "Actions",
  })
  useKeyboardShortcut("c>p", globalActions["create-prospect"], {
    description: "Create new prospect",
    category: "Actions",
  })
  useKeyboardShortcut("c>o", globalActions["create-contact"], {
    description: "Create other contact",
    category: "Actions",
  })

  useKeyboardShortcut("g>t", globalActions["go-to-tasks"], {
    description: "Go to tasks",
    category: "Navigation",
  })

  useKeyboardShortcut("g>h", globalActions["go-to-home"], {
    description: "Go home",
    category: "Navigation",
  })

  useKeyboardShortcut("g>s", globalActions["go-to-book-settings"], {
    description: "Go to book settings",
    category: "Navigation",
  })

  useKeyboardShortcut("g>c", globalActions["go-to-clients"], {
    description: "Go to clients",
    category: "Navigation",
  })

  useKeyboardShortcut("g>p", globalActions["go-to-prospects"], {
    description: "Go to prospects",
    category: "Navigation",
  })

  useKeyboardShortcut("g>o", globalActions["go-to-contacts"], {
    description: "Go to contacts",
    category: "Navigation",
  })

  useKeyboardShortcut("g>d", globalActions["go-to-opportunities"], {
    description: "Go to opportunities",
    category: "Navigation",
  })

  useKeyboardShortcut("g>j", globalActions["go-to-projects"], {
    description: "Go to projects",
    category: "Navigation",
  })

  useKeyboardShortcut("g>m", globalActions["go-to-meetings"], {
    description: "Go to meetings",
    category: "Navigation",
  })

  useKeyboardShortcut("g>q", globalActions["go-to-sequences"], {
    description: "Go to sequences",
    category: "Navigation",
  })

  useKeyboardShortcut("g>b", globalActions["go-to-book-chat"], {
    description: "Go to book chat",
    category: "Navigation",
  })

  useKeyboardShortcut("c>e", globalActions["compose-email"], {
    description: "Compose email",
    category: "Actions",
  })

  return null
}

export default GlobalHotkeys
